(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/personal-information-doc-link.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/personal-information-doc-link.js');
'use strict';

const isNativeApp = svs.core.config.data.svsconfig.isNativeApp;
const PersonalInformationDocLink = () => {
  var _svs$playerRegistrati;
  return React.createElement("a", {
    className: "u-text-decoration-underline",
    href: (_svs$playerRegistrati = svs.playerRegistration.data) === null || _svs$playerRegistrati === void 0 || (_svs$playerRegistrati = _svs$playerRegistrati.cmsData) === null || _svs$playerRegistrati === void 0 || (_svs$playerRegistrati = _svs$playerRegistrati.personalInformationDoc) === null || _svs$playerRegistrati === void 0 ? void 0 : _svs$playerRegistrati.url,
    rel: "noreferrer",
    target: isNativeApp ? '' : '_blank'
  }, "behandling av personuppgifter");
};
svs.playerRegistration.components.PersonalInformationDocLink = PersonalInformationDocLink;

 })(window);